module.exports = __webpack_public_path__ + "static/media/nova.af6149b2.png";